// extracted by mini-css-extract-plugin
export default {"root":"Tag_root__RDiAi","remove":"Tag_remove__vghhS","locked":"Tag_locked__gAx1e"};